<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>
          Liquidación de ventas
          {{
            numero_documento !== ""
              ? tipo_documento + "-" + numero_documento
              : ""
          }}
        </h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button
            v-show="!consultaRealizada"
            @click="consultar"
            class="btn-info btn--bigger"
          >
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button
            v-show="numero_documento == '' || id !== ''"
            type="button"
            @click="liquidar"
            class="btn-success"
          >
            <i class="fa fa-check"></i><span>Liquidar</span>
          </button>
          <button
            v-show="numero_documento != ''"
            type="button"
            @click="imprimirPdf"
            class="btn-danger"
          >
            <i class="fa fa-file-pdf-o"></i><span>PDF</span>
          </button>
          <button
            v-show="numero_documento != ''"
            type="button"
            @click="imprimirExcel"
            class="btn-success"
          >
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
          <button type="button" @click="nuevaLiquidacion" class="btn-primary">
            <i class="fa fa-plus"></i><span>Nueva liquidación</span>
          </button>
          <button v-show="numero_documento != ''" type="button" @click="generarHistorial" class="btn-info">
            <i class="fa fa-table"></i><span>Historial de Ventas</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div
              class="form-field select2 select2-field--stretch"
              :class="{
                'select2--disabled': consultaRealizada,
              }"
            >
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="bodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="fecha_liquidacion"
                  v-model="form.fecha_liquidacion"
                  locale="es"
                  no-label
                  :disabled="consultaRealizada"
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm"
                  label="Seleccione fecha..."
                />
                <label>Fecha de liquidación</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div
              class="form-field select2"
              :class="{
                'select2--disabled': consultaRealizada,
              }"
            >
              <div class="select2-field">
                <v-select
                  @search="searchVendedores"
                  @input="inputSupervisor"
                  v-model="selectedSupervisor"
                  :options="vendedores"
                  placeholder="Seleccione..."
                  label="descripcion"
                  id="vendedor"
                ></v-select>
                <label for="vendedor">Vendedor</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde_venta"
                  v-model="form.desde_venta"
                  locale="es"
                  only-date
                  no-label
                  :disabled="consultaRealizada"
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Fecha inicial de corte de venta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta_venta"
                  v-model="form.hasta_venta"
                  locale="es"
                  only-date
                  no-label
                  :disabled="consultaRealizada"
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Fecha final de corte de venta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde_recaudacion"
                  v-model="form.desde_recaudacion"
                  locale="es"
                  only-date
                  no-label
                  :disabled="consultaRealizada"
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Fecha inicial de recaudación</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta_recaudacion"
                  v-model="form.hasta_recaudacion"
                  locale="es"
                  only-date
                  no-label
                  :disabled="consultaRealizada"
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Fecha final de recaudación</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="consultaRealizada" class="row mt-2">
      <div class="col-xs-12 col-md-6">
        <tabs>
          <tab name="Canceladas">
            <ventas-liquidacion :liquidacion_id="id" id="C" @mover="mover" @input="inputCanceladas" :supervisor_id="form.supervisor_id" :tipoVenta="'C'" v-model="form.ventasCanceladas"></ventas-liquidacion>
          </tab>
          <tab name="Devoluciones completas">
            <ventas-liquidacion :liquidacion_id="id" id="DC" @mover="mover" @input="inputDevolucionesCompletas" :supervisor_id="form.supervisor_id" :tipoVenta="'DC'" v-model="form.devolucionesCompletas"></ventas-liquidacion>
          </tab>
          <tab name="Devoluciones parciales">
            <ventas-liquidacion :liquidacion_id="id" id="DP" @mover="mover" @input="inputDevolucionesParciales" :supervisor_id="form.supervisor_id" :tipoVenta="'DP'" v-model="form.devolucionesParciales"></ventas-liquidacion>
          </tab>
          <tab name="Retornos">
            <ventas-liquidacion :liquidacion_id="id" id="R" @mover="mover" @input="inputRetornos" :supervisor_id="form.supervisor_id" :tipoVenta="'R'" v-model="form.retornos"></ventas-liquidacion>
          </tab>
          <tab name="Incobrables">
            <ventas-liquidacion :liquidacion_id="id" id="I" @mover="mover" @input="inputIncobrables" :supervisor_id="form.supervisor_id" :tipoVenta="'I'" v-model="form.incobrables"></ventas-liquidacion>
          </tab>
        </tabs>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="card">
          <div class="card__title">
            <h5>Movimientos</h5>
            <div class="card__controls">
              <div class="form-field">
                <input-field
                  v-model="searchMovimientos"
                  id="busqueda_movimientos"
                  placeholder="Realice una búsqueda..."
                ></input-field>
              </div>
            </div>
          </div>
          <div style="max-height: 300px" class="card__content">
            <div class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Tipo de movimiento</th>
                    <th>Fecha</th>
                    <th>Día</th>
                    <th>Detalle</th>
                    <th>Valor</th>
                    <th>Saldo</th>
                    <th>Valor seleccionado</th>
                    <th>
                      <button
                        v-show="consultaRealizada"
                        @click="agregarMovimientos"
                        tooltip="Agregar venta"
                        class="btn-success"
                      >
                        <i class="fa fa-plus"></i>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-show="coincideMovimientos(movimiento)"
                    :class="{ 'tr--canceled': movimiento.valor < 0 }"
                    v-for="(movimiento, index) in form.movimientos"
                    :key="movimiento.id"
                  >
                    <td>
                      {{ movimiento.descripcion_tipo_movimiento }}
                    </td>
                    <td>
                      {{ movimiento.fecha }}
                    </td>
                    <td>
                        {{ movimiento.nombre_dia }}
                      </td>
                    <td>
                      {{ movimiento.detalle }}
                    </td>
                    <td>
                      {{ moneyFormat(movimiento.valor) }}
                    </td>
                    <td>
                      {{ moneyFormat(movimiento.saldo) }}
                    </td>
                    <td>
                      {{ moneyFormat(movimiento.valor_pago) }}
                    </td>
                    <td>
                      <button
                        @click="quitarMovimiento(index)"
                        tooltip="Quitar"
                        class="btn-danger btn--text"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                      
                    </td>
                  </tr>
                  <tr class="tr--canceled" v-show="form.retornos.length > 0">
                    <td>
                      Retornos
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ moneyFormat(totalRetornado * -1) }}
                    </td>
                    <td>
                      {{ moneyFormat(totalRetornado) }}
                    </td>
                    <td>
                      {{ moneyFormat(totalRetornado * -1) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="6" scope="row">Totales</th>
                    <td colspan="2">
                      {{
                        moneyFormat(
                          totalMovimientos
                        )
                      }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="consultaRealizada" class="row mt-2">
      <div class="col-xs-12 col-md-8">
        <div class="card">
          <div class="card__title">
            <h5>Ventas</h5>
          </div>
          <div class="card__content">
            <div style="max-height: 300px" class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Semana Anterior</th>
                    <th>Liquidación</th>
                    <th>Próxima Semana</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="table-responsive">
                        <table class="custom-table">
                          <thead>
                            <tr>
                              <th>Nuevas</th>
                              <th>Pendientes</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {{ form.ventas_nuevas }}
                              </td>
                              <td>
                                {{ form.ventas_pendientes }}
                              </td>
                              <td>
                                {{ form.ventas_totales }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td>
                      <div class="table-responsive">
                        <table class="custom-table">
                          <thead>
                            <tr>
                              <th>Canceladas</th>
                              <th>Dev. Completa</th>
                              <th>Dev. Parcial</th>
                              <th>Retorno</th>
                              <th>Incobrable</th>
                              <th>Total/Pendiente</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {{ form.canceladas }}
                              </td>
                              <td>
                                {{ form.dev_completa }}
                              </td>
                              <td>
                                {{ form.dev_parcial }}
                              </td>
                              <td>
                                {{ form.retorno }}
                              </td>
                              <td>
                                {{ form.incobrable }}
                              </td>
                              <td>
                                {{ totalPendientes }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td>
                      <div class="table-responsive">
                        <table class="custom-table">
                          <thead>
                            <tr>
                              <th>Pendiente</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {{ form.proximas_pendientes }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Comisiones</h5>
          </div>
          <div class="card__content">
            <div style="max-height: 300px" class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Detalle</th>
                    <th>Valor</th>
                    <th>Cantidad</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="comision in form.comisiones"
                    :key="comision.descripcion"
                  >
                    <td>
                      {{ comision.descripcion }}
                    </td>
                    <td>
                      {{ moneyFormat(comision.comision) }}
                    </td>
                    <td>
                      {{ comision.cantidad }}
                    </td>
                    <td>
                      {{ moneyFormat(comision.total) }}
                    </td>
                  </tr>
                  <tr v-show="form.comisiones.length === 0">
                    <td colspan="4">
                      <strong>No se ha encontrado comisiones.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Total de comisión</th>
                    <th>Total de descuentos</th>
                    <th>Líquido a recibir</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ moneyFormat(totalComision) }}
                    </td>
                    <td>
                      {{ moneyFormat(totalGastos) }}
                    </td>
                    <td>
                      {{ moneyFormat(liquidoRecibir) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :clickToClose="false"
      name="tableSelectMov"
      height="auto"
      width="70%"
      scrollable
      resizable
      adaptive
      reset
    >
      <k-table-select
        v-model="form.movimientos"
        :columnas="[
          {
            nombre: 'tipo_movimiento.descripcion',
            descripcion: 'Tipo de movimiento',
          },
          {
            nombre: 'fecha',
            descripcion: 'Fecha',
            sortable: true,
          },
          {
            nombre: 'nombre_dia',
            descripcion: 'Día',
            sortable: true,
          },
          {
            nombre: 'detalle',
            descripcion: 'Detalle',
            sortable: true,
          },
          {
            nombre: 'valor',
            descripcion: 'Valor',
            money: true,
            sortable: true,
          },
          {
            nombre: 'saldo',
            descripcion: 'Saldo',
            money: true,
            sortable: true,
          },
          {
            nombre: 'valor_pago',
            descripcion: 'Valor seleccionado',
            money: true,
            sortable: true,
          }
        ]"
        saldoSeleccionable
        :params="{
          vendedor_id: form.supervisor_id
        }"
        @cerrar="cerrarMovimientos"
        :urlConsulta="url + '/movimientos-nomina-supervisor'"
        title="Seleccione uno o varios movimientos"
        ref="kTableSelectMov"
        @seleccionar="seleccionarMovimientos"
      ></k-table-select>
    </modal>
  </div>
</template>

<script>
import KTableSelect from "../../general/KTableSelect.vue";
import VentasLiquidacion from './VentasLiquidacion.vue';

export default {
  components: {
    KTableSelect, VentasLiquidacion
  },
  computed: {
    proximasPendientes: function () {
      let ventas_totales = parseInt(this.form.ventas_totales);
      if (isNaN(ventas_totales))
        ventas_totales = 0;
      let proximasPendientes = ventas_totales - this.totalPendientes;
      this.form.proximas_pendientes = proximasPendientes;
      return proximasPendientes;
    },
    totalPendientes: function () {
      let canceladas = parseInt(this.form.canceladas);
      if (isNaN(canceladas))
        canceladas = 0;
      let dev_completa = parseInt(this.form.dev_completa);
      if (isNaN(dev_completa))
        dev_completa = 0;
      let dev_parcial = parseInt(this.form.dev_parcial);
      if (isNaN(dev_parcial))
        dev_parcial = 0;
      let totalPendientes = canceladas + dev_completa + dev_parcial;
      this.form.total_pendiente = totalPendientes;
      return totalPendientes;
    },
    totalMovimientos: function () {
      let total = 0;
      let totalMovimientos = _.sumBy(this.form.movimientos, function (o) {
        return parseFloat(o.valor_pago);
      });
      total = round(totalMovimientos - this.totalRetornado, 2);
      return total;
    },
    totalRetornado: function () {
      let totalRetornado = 0;
      for (let i = 0; i < this.form.retornos.length; i++) {
        let valor = parseFloat(this.form.retornos[i].valor_pago);
        if (isNaN(valor))
          valor = 0;
        totalRetornado += valor;
      }
      return totalRetornado;
    },
    liquidoRecibir: function () {
      let liquidoRecibir = round(this.totalComision + this.totalGastos, 2);
      this.form.liquido_recibir = liquidoRecibir;
      return liquidoRecibir;
    },
    totalComision: function () {
      let comision = 0;
      for (let i = 0; i < this.form.comisiones.length; i++) {
        let valorComision = parseFloat(this.form.comisiones[i].total);
        if (isNaN(valorComision)) valorComision = 0;
        if (valorComision > 0) comision += valorComision;
      }
      comision = round(comision, 2);
      this.form.total_comisiones = comision;
      return comision;
    },
    totalGastos: function () {
      let totalGastos = 0;
      for (let i = 0; i < this.form.movimientos.length; i++) {
        let valor = parseFloat(this.form.movimientos[i].valor_pago);
        totalGastos += valor;
      }
      totalGastos = totalGastos - this.totalRetornado;
      this.form.total_gastos = round(totalGastos, 2);
      return totalGastos;
    },
  },
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    generarHistorial: function () {
      window.open(url + '/historial-ventas-vendedor?tipo_fecha=P&desde=' + 
      moment(new Date(this.form.fecha_liquidacion)).format('YYYY-MM-DD') + '&hasta=' + 
      moment(new Date(this.form.fecha_liquidacion)).format('YYYY-MM-DD') + '&vendedor_id=' + 
      this.form.supervisor_id, '_blank');
    },
    imprimirExcel: function () {
      window.open(url + '/liquidacion-ventas/' + this.id + '/excel', '_blank');
    },
    imprimirPdf: function () {
      window.open(url + '/liquidacion-ventas/' + this.id + '/pdf', '_blank');
    },
    mover: function (tarjeta, tipoVenta, moverA) {
      if (tipoVenta === 'C') {
        this.form.ventasCanceladas.splice(this.form.ventasCanceladas.indexOf(tarjeta), 1);
      }
      else if (tipoVenta === 'DC') {
        this.form.devolucionesCompletas.splice(this.form.devolucionesCompletas.indexOf(tarjeta), 1);
      }
      else if (tipoVenta === 'DP') {
        this.form.devolucionesParciales.splice(this.form.devolucionesParciales.indexOf(tarjeta), 1);
      }
      else if (tipoVenta === 'R') {
        this.form.retornos.splice(this.form.retornos.indexOf(tarjeta), 1);
      }
      else if (tipoVenta === 'I') {
        this.form.incobrables.splice(this.form.incobrables.indexOf(tarjeta), 1);
      }
      if (moverA === 'C') {
        this.form.ventasCanceladas.push(tarjeta);
      }
      else if (moverA === 'DC') {
        this.form.devolucionesCompletas.push(tarjeta);
      }
      else if (moverA === 'DP') {
        this.form.devolucionesParciales.push(tarjeta);
      }
      else if (moverA === 'R') {
        this.form.retornos.push(tarjeta);
      }
      else if (moverA === 'I') {
        this.form.incobrables.push(tarjeta);
      }
      this.inputCanceladas();
      this.inputDevolucionesCompletas();
      this.inputDevolucionesParciales();
      this.inputRetornos();
      this.inputIncobrables();
    },
    inputCanceladas: function () {
      this.form.canceladas = this.form.ventasCanceladas.length;
      this.recalcularComisiones();
    },
    inputDevolucionesCompletas: function () {
      this.form.dev_completa = this.form.devolucionesCompletas.length;
    },
    inputDevolucionesParciales: function () {
      this.form.dev_parcial = this.form.devolucionesParciales.length;
    },
    inputRetornos: function () {
      this.form.retorno = this.form.retornos.length;
    },
    inputIncobrables: function () {
      this.form.incobrable = this.form.incobrables.length;
    },
    recalcularComisiones: function () {
      for (let i = 0; i < this.form.comisiones.length; i++) {
        let valorComision = this.form.comisiones[i].comision;
        let total = 0;
        for (let j = 0; j < this.form.ventasCanceladas.length; j++) {
          let valorTotal = parseFloat(this.form.ventasCanceladas[j].valor_comision);
          if (isNaN(valorTotal))
            valorTotal = 0;
          if (valorTotal == valorComision) {
              total++;
          }
        }
        this.form.comisiones[i].cantidad = total;
        this.form.comisiones[i].total = round(valorComision * total, 2);
      }
    },
    coincideMovimientos: function (movimiento) {
      let busqueda = this.searchMovimientos.toUpperCase();
      if (busqueda != "") {
        return (
          movimiento.detalle.toUpperCase().includes(busqueda) ||
          movimiento.descripcion_tipo_movimiento
            .toUpperCase()
            .includes(busqueda) ||
          movimiento.fecha.includes(busqueda) ||
          movimiento.valor.toString().includes(busqueda)
        );
      } else return true;
    },
    quitarMovimiento: function (index) {
      this.form.movimientos.splice(index, 1);
    },
    seleccionarMovimientos: function (movimientos) {
      this.form.movimientos.splice(0, this.form.movimientos.length);
      for (let i = 0; i < movimientos.length; i++) {
        let valorPago = movimientos[i].valor_pago *
            (movimientos[i].tipo_movimiento.tipo == "I" ? 1 : -1);
        this.form.movimientos.push({
          id: movimientos[i].id,
          descripcion_tipo_movimiento:
            movimientos[i].tipo_movimiento.descripcion,
          detalle: movimientos[i].detalle,
          fecha: movimientos[i].fecha,
          valor:
            movimientos[i].valor *
            (movimientos[i].tipo_movimiento.tipo == "I" ? 1 : -1),
          saldo: round(parseFloat(movimientos[i].saldo) + Math.abs(valorPago), 2) ,
          valor_pago: valorPago,
          nombre_dia: movimientos[i].nombre_dia
        });
      }
      this.$modal.hide("tableSelectMov");
    },
    cerrarMovimientos: function () {
      this.$modal.hide("tableSelectMov");
    },
    nuevaLiquidacion: function () {
      swal({
        title: "Confirmación",
        text: "¿Desea registrar una nueva liquidación?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.consultaRealizada = false;
          this.form.comisiones.splice(0, this.form.comisiones.length);
          this.id = "";
          this.numero_documento = "";
          this.tipo_documento = "LQ";
          this.form.ventas_nuevas = 0;
          this.form.ventas_pendientes = 0;
          this.form.ventas_totales = 0;
          this.form.canceladas = 0;
          this.form.dev_completa = 0;
          this.form.dev_parcial = 0;
          this.form.incobrable = 0;
          this.form.total_pendiente = 0;
          this.form.proximas_pendientes = 0;
          this.selectedSupervisor = null;
          this.form.valor_otros = 0;
          this.form.valor_prestamos = 0;
          this.form.valor_retornos = 0;
          this.form.valor_anticipos = 0;
          this.form.valor_incobrables = 0;
          this.form.valor_viaticos = 0;
          this.inputSupervisor();
        }
      });
    },
    liquidar: function () {
      if (this.liquidoRecibir == 0) {
        swal('El valor líquido a recibir debe ser igual mayor o igual a cero.', 'Aviso', 'warning');
        return;
      }
      swal({
        title: "Confirmación",
        text: "¿Desea liquidar al supervisor seleccionado?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.form.id = this.id;
          axios
            .post(url + "/liquidacion-ventas", this.form)
            .then(({ data }) => {
              this.id = data.id;
              this.tipo_documento = data.tipo_documento;
              this.numero_documento = data.numero_documento;
              swal(
                "La liquidación fue realizada exitósamente.",
                "Aviso",
                "success"
              );
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    inputBodega: function () {
      this.form.bodega_id = "";
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    searchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.vendedores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
      xmlhttp.send();
    },
    inputSupervisor: function () {
      if (this.selectedSupervisor != null)
        this.form.supervisor_id = this.selectedSupervisor.id;
      else this.form.supervisor_id = "";
    },
    consultar: function () {
      let desde = moment(this.form.desde_venta);
      let hasta = moment(this.form.hasta_venta);
      if (hasta.diff(desde, 'days') > 7) {
        swal('No se permite consultas mayores a una semana en la fecha de corte de venta.', 'Aviso', 'warning');
        return;
      }
      desde = moment(this.form.desde_recaudacion);
      hasta = moment(this.form.hasta_recaudacion);
      if (hasta.diff(desde, 'days') > 7) {
        swal('No se permite consultas mayores a una semana en la fecha de recaudación.', 'Aviso', 'warning');
        return;
      }
      if (this.selectedBodega == null)
        swal("Debe seleccionar una bodega.", "Aviso", "warning");
      else if (this.selectedSupervisor == null) {
        swal("Debe seleccionar un vendedor", "Aviso", "warning");
      } else {
        axios
          .get(url + "/liquidacion-ventas", {
            params: this.form,
          })
          .then(({ data }) => {
            this.form.ventasCanceladas.splice(0, this.form.ventasCanceladas.length);
            this.form.incobrables.splice(0, this.form.incobrables.length);
            this.form.devolucionesCompletas.splice(0, this.form.devolucionesCompletas.length);
            this.form.devolucionesParciales.splice(0, this.form.devolucionesParciales.length);
            this.form.retornos.splice(0, this.form.retornos.length);
            for (let i = 0; i < data.tarjetas.length; i++) {
              let detail = {
                    id: data.tarjetas[i].id,
                    numero_documento: data.tarjetas[i].numero_documento,
                    valor_total: data.tarjetas[i].valor_total,
                    total_abonado: data.tarjetas[i].total_pagado,
                    nombre_cliente: data.tarjetas[i].cliente.descripcion_cliente,
                    fecha: data.tarjetas[i].fecha,
                    valor_comision: data.tarjetas[i].valor_comision,
                    valor_pago: data.tarjetas[i].valor_pago,
                    saldo_incobrable: data.tarjetas[i].saldo_incobrable,
                    saldo_retorno: data.tarjetas[i].saldo_retorno
                  };
                if (data.tarjetas[i].estado_tarjeta === 'C') {
                  this.form.ventasCanceladas.push(detail);
                }
                else if (data.tarjetas[i].estado_tarjeta === 'I') {
                  this.form.incobrables.push(detail);
                }
                else if (data.tarjetas[i].estado_tarjeta === 'DC') {
                  this.form.devolucionesCompletas.push(detail);
                }
                else if (data.tarjetas[i].estado_tarjeta === 'DP') {
                  this.form.devolucionesParciales.push(detail);
                }
                else if (data.tarjetas[i].estado_tarjeta === 'R') {
                  this.form.retornos.push(detail);
                }
            }
            if (data.liqExistente != null) {
              this.id = data.liqExistente.id;
              this.tipo_documento = data.liqExistente.tipo_documento;
              this.numero_documento = data.liqExistente.numero_documento;
              this.form.ventas_nuevas = data.liqExistente.ventas_nuevas;
              this.form.ventas_pendientes = data.liqExistente.ventas_pendientes;
              this.form.ventas_totales = data.liqExistente.ventas_totales;
              this.form.canceladas = data.liqExistente.canceladas;
              this.form.dev_completa = data.liqExistente.dev_completa;
              this.form.dev_parcial = data.liqExistente.dev_parcial;
              this.form.retorno = data.liqExistente.retorno;
              this.form.incobrable = data.liqExistente.incobrable;
              this.form.total_pendiente = data.liqExistente.total_pendiente;
              this.form.proximas_pendientes = data.liqExistente.proximas_pendientes;
              this.form.total_comisiones = data.liqExistente.total_comisiones;
              this.form.total_gastos = data.liqExistente.total_gastos;
              this.form.liquido_recibir = data.liqExistente.liquido_recibir;
              this.form.comisiones = data.comisiones;
              this.form.movimientos.splice(0, this.form.movimientos.length);
              for (let i = 0; i < data.liqExistente.cancelaciones.length; i++) {
                let mov = data.liqExistente.cancelaciones[i].movimiento != null?data.liqExistente.cancelaciones[i].movimiento:data.liqExistente.cancelaciones[i].movimiento_caja;
                let valorPago = parseFloat(data.liqExistente.cancelaciones[i].valor_pago) *
                (mov.tipo_movimiento.tipo == "I" ? 1 : -1);
                this.form.movimientos.push({
                  id: mov.id,
                  descripcion_tipo_movimiento: mov.tipo_movimiento.descripcion,
                  detalle: mov.detalle,
                  fecha:  mov.fecha,
                  valor:
                    (parseFloat(mov.valor)) *
                    (mov.tipo_movimiento.tipo == "I" ? 1 : -1),
                  saldo: round(parseFloat(mov.saldo), 2) ,
                  valor_pago: valorPago,
                  nombre_dia: mov.descripcion_dia
                });
              }
            } else {
              this.id = "";
              this.tipo_documento = "";
              this.numero_documento = "";
              this.form.comisiones = data.comisiones;
              this.form.ventas_nuevas = data.totalVentasNuevas;
              this.form.ventas_pendientes = data.totalPendientes;
              this.form.ventas_totales = data.totalVentasNuevas + data.totalPendientes;
              this.inputCanceladas();
              this.inputIncobrables();
              this.inputDevolucionesCompletas();
              this.inputDevolucionesParciales();
              this.inputRetornos();
            }
            
            this.consultaRealizada = true;
          });
      }
    },
    agregarMovimientos: function () {
      this.$modal.show("tableSelectMov");
    },
  },
  data: function () {
    return {
      vendedores: [],
      lodash: _,
      url: url,
      moneyFormat: moneyFormat,
      selectedBodega: null,
      searchMovimientos: "",
      form: {
        hasta_recaudacion: moment(new Date()).format('YYYY-MM-DD'),
        desde_recaudacion: moment(new Date()).format('YYYY-MM-DD'),
        hasta_venta: moment(new Date()).format('YYYY-MM-DD'),
        desde_venta: moment(new Date()).format('YYYY-MM-DD'),
        bodega_id: "",
        fecha_liquidacion: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        supervisor_id: "",
        ventas_nuevas: 0,
        ventas_pendientes: 0,
        ventas_totales: 0,
        canceladas: 0,
        dev_completa: 0,
        dev_parcial: 0,
        retorno: 0,
        incobrable: 0,
        total_pendiente: 0,
        proximas_pendientes: 0,
        total_comisiones: 0,
        total_gastos: 0,
        liquido_recibir: 0,
        movimientos: [],
        comisiones: [],
        devolucionesCompletas: [],
        devolucionesParciales: [],
        retornos: [],
        incobrables: [],
        ventasCanceladas: [],
        id: ''
      },
      selectedSupervisor: null,
      liquidacionVentas: [],
      comisiones: [],
      supervisores: [],
      moneyFormat: moneyFormat,
      money: money,
      id: "",
      tipo_documento: "LQ",
      numero_documento: "",
      consultaRealizada: false,
    };
  },
  mounted: function () {
    if (this.bodegas.length == 1) {
      this.selectedBodega = this.bodegas[0];
      this.inputBodega();
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/LiquidacionVentas.vue